import { STATUS_STYLES } from "@/lib/academy/programs";

export const AcademyLockup = ({ id = "academy-lockup", className = "w-[280px]" }) => (
  <span data-testid={id} role="img" aria-label="DCYB Academy" className={`academy-lockup ${className}`}>
    <img src="/dcyb-wordmark.png" alt="" width="1169" height="245" draggable="false" />
    <span aria-hidden="true" className="academy-lockup-word">Academy</span>
  </span>
);

export const Readout = ({ children, className = "" }) => (
  <p className={`inline-flex items-center gap-2.5 font-space-mono text-[10px] sm:text-[11px] text-[#3C2A27] ${className}`}><span aria-hidden="true" className="academy-node" />{children}</p>
);

export const StatusBadge = ({ status, label, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1.5 border px-2 py-1 font-mono-label text-[10px] whitespace-nowrap ${STATUS_STYLES[status] || STATUS_STYLES.planned}`}>
    <span aria-hidden="true" className={`w-1.5 h-1.5 rounded-full ${status === "sample" || status === "inquiry" ? "bg-[#F6101A]" : "bg-[#8A94A2]"}`} />
    {label}
  </span>
);

export const AcademySectionHeader = ({ id, label, title, intro, children }) => (
  <div className="grid grid-cols-12 gap-y-6 gap-x-6 mb-12">
    <div className="col-span-12 lg:col-span-7">
      <Readout className="mb-5"><span data-testid={`${id}-label`}>{label}</span></Readout>
      <h2 id={`${id}-title`} data-testid={`${id}-headline`} className="font-display text-[1.65rem] sm:text-4xl lg:text-[2.75rem] leading-[1.2] sm:leading-[1.2] text-[#160907] text-balance">{title}</h2>
    </div>
    <div className="col-span-12 lg:col-span-5 lg:pt-11">
      <p data-testid={`${id}-intro`} className="text-base sm:text-lg text-[#3D4049] leading-relaxed max-w-xl">{intro}</p>
      {children}
    </div>
  </div>
);
